export enum RecurringInvoiceDelivery {
  Create = 'create',
  CreateAndSend = 'create-and-send',
  CreateDraft = 'create-draft',
}
